export default "__VITE_ASSET__N0U_Tf4u__"